<template>
  <div class="text-input clearfix" v-show="show">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label
        :for="options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div :class="{ 'input-group': maxLength }">
          <input class="form-control" type="text"
            :placeholder="options.placeholder || ''"
            :class="formControlValidationClass"
            :value="value"
            @input="validate($event.target.value)"
            :name="options.name"/>
          <div v-if="maxLength && value" class="input-group-addon">
            <span class="input-group-text">
              {{ maxLength - value.length >= 0 ? maxLength - value.length : 0 }} chars
            </span>
          </div>
        </div>
        <div :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/vuex/api'
import {
  validationClass,
  formControlValidationClass,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'TextInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: ''
        }
      }
    }
  },
  computed: {
    validationClass,
    formControlValidationClass,
    validationMessage,
    invalidMessage () {
      if (this.maxLength && this.value.length > this.maxLength) {
        return 'Max characters cannot exceed ' + this.maxLength
      } else if (this.minLength && this.value.length < this.minLength) {
        return `${this.minLength} minimum characters are required`
      } else {
        return this.options.label + ' is required'
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      isLength: true,
      isRegex: true,
      minLength: 1,
      maxLength: false,
      watcher: false,
      show: true
    }
  },
  mounted () {
    if (this.options.hidden) this.show = false
    if (this.options.maxLength) { this.maxLength = this.options.maxLength }
    if (this.options.minLength) { this.minLength = this.options.minLength }
    this.validate(this.value)
    this.isDirty = false
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length >= this.minLength
        if (this.isLength && this.maxLength) {
          this.isValid = val.length <= this.maxLength
        }
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    },
    async geocode (val) {
      let instance = new Api()
      let addressComponents = await instance.geocode(val)
      if (this.options.name.toLowerCase().includes('suburb')) {
        this.validate(addressComponents.suburb)
      } else if (this.options.name.toLowerCase().includes('postcode')) {
        this.validate(addressComponents.postcode)
      }
    },
    async checkMultipleAccounts (val) {
      if (val) {
        let instance = new Api()
        let response = await instance.hasMultipleAccounts(val)
        if (response.multipleAccounts) {
          this.show = true
          this.options.required = true
          this.validate('')
        } else {
          this.show = false
          this.options.required = false
          this.validate()
        }
      }
    },
    runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        if (!this.value) this.watcher = true
        if (this.watcher) {
          if (val) {
            switch (name) {
              case 'address':
                this.geocode(val)
                break
              case 'email':
                this.checkMultipleAccounts(val)
                break
              case 'company':
                this.show = true
                this.options.required = true
                this.validate('')
                break
              case 'companyOption':
                if (val === 'Add Company') {
                  this.show = true
                  this.options.required = true
                  this.validate('')
                } else {
                  this.show = false
                  this.options.required = false
                  this.validate()
                }
                break
              // DANGER : Makes not required for account holders as well so must fix
              case 'lots':
                if (val > 1) {
                  this.options.required = true
                  this.validate()
                } else {
                  this.options.required = false
                  this.validate()
                }
                break
            }
          } else {
            switch (name) {
              // When company field is empty then remove this field.
              case 'company':
                this.show = false
                this.options.required = false
                this.validate()
                break
            }
            this.validate('')
            this.isDirty = false
          }
        }
        this.watcher = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/TextInput.vue